import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useMediaQuery, useTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import FeeRow from '../../../../components/FeeRow';
import FormHeader from '../../../../components/form-items/FormHeader';
import { AppealFeesInSummary } from '../../../../api/candidate/appeal/model';

const useStyles = makeStyles()((theme) =>
({
  container: {
    maxWidth: 960,
  },
  value: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  payableFeesHeader: {
    paddingBottom: theme.spacing(1),
    color: theme.color.text.textHeader,
  },
  totalPayableFeesContainer: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(6),
  },
  totalPayableFeesLabel: {
    color: theme.color.text.textHeader,
  },
  payableFeesContainer: {
    paddingBottom: theme.spacing(1),
  },
}));

type AppealFeesProps = AppealFeesInSummary;

const AppealFees = ({
  gstRegNo,
  totalGst,
  totalPayable,
  gstAbsorbed,
  totalPayableFeeExcludingGST,
  totalPayableFeeIncludingGST,
}: AppealFeesProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    (<Box className={classes.container}>
      <FormHeader title={t('Appeal->>AppealFees.Appeal Fees')} />
      <Grid md={6} sm={12} xs={12}>
        <KeyValue
          id="gstRegNo"
          keyText={t('Appeal->>AppealFees.GST Reg No.')}
          valueText={gstRegNo}
        />
      </Grid>
      <div>
        <Grid
          md={12}
          container
          direction="row"
          justify="flex-start"
          className={classes.payableFeesHeader}
        >
          <Grid xs={12} sm={9} md={6}>
            <Typography display="block" variant="h4" align="left">
              {t('Appeal->>AppealFees.Total Appeal Fees')}
            </Typography>
          </Grid>
          {!isMobile && (
            <Grid
              container
              xs={12}
              sm={3}
              md={2}
              direction="row"
              justify={isMobile ? 'flex-start' : 'flex-end'}
            >
              <Typography
                noWrap
                display="block"
                variant="h5"
                align="left"
                className={classes.value}
              >
                {t('components->>SelectedSubjectReview.Amount (SGD)')}
              </Typography>
            </Grid>
          )}
        </Grid>

        <FeeRow
          label={t('components->>SelectedSubjectReview.Goods and Services Tax (GST)')}
          value={totalGst}
          containerClassName={classes.payableFeesContainer}
        />

        <FeeRow
          label={t('appeal->>AppealSummary.FeeDetails.TotalPayableFeeInclGst')}
          value={totalPayableFeeIncludingGST}
          containerClassName={classes.payableFeesContainer}
        />

        <FeeRow
          bold
          ish4
          containerClassName={classes.totalPayableFeesContainer}
          labelClassName={classes.totalPayableFeesLabel}
          label={t('components->>SelectedSubjectReview.TotalPayable')}
          value={totalPayable}
        />
      </div>
    </Box>)
  );
};

export default AppealFees;
